<template>
  <div style="margin-top: -3px;">
    <b-form-radio v-model="filter[cellKey]" :value="true">Checked</b-form-radio>
    <b-form-radio v-model="filter[cellKey]" :value="false">Unchecked</b-form-radio>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  props: ['cellKey', 'filter']
}
</script>
